import { Helmet } from "react-helmet";

const SiteTitle = ({ title, isVisibleSuffix = true }) => {
  return (
    <Helmet>
      <title>
        {title} | {isVisibleSuffix ? "پنل مدیریت کارباما" : ""}
      </title>
    </Helmet>
  );
};

export default SiteTitle;
